/**
 * 亲密关系卡片
 * */
import React from 'react';
import Util from '../../../script/util';
import { _change_affinity_modal } from '../../../../src/store/Action';
import './IntimateAffinityCard.scss';

const IntimateAffinityCard = ({ data, isMic }) => {
  const openAffinitySpace = () => {
    const { otherUid, searchUid, intimateRelationId } = data;
    _change_affinity_modal({
      affinitySpaceModal: true,
      affinitySpaceData: { otherUid, searchUid, intimateRelationId },
    });
  };
  return data.level >= 3 || !!isMic ? (
    <div
      className={`intimate-affinity-item lv${data.level} ${isMic ? 'mic' : ''}`}
      style={{
        backgroundImage: `url(${Util.transImgUrl(isMic ? data?.micRelCardIcon : data?.relCardIcon, '345x148')})`,
      }}
      key={data.intimateRelationId}
      onClick={openAffinitySpace}
    >
      <div className="intimate-affinity-item-level">
        <span style={{ color: data?.relationConfig?.relationConfigStyle }}>
          {data?.relationConfig?.relationConfigName}LV.{data.level}
        </span>
      </div>
      <div className="intimate-affinity-item-top">
        <div className="intimate-affinity-item-top-left">
          <div className="intimate-affinity-item-top-avatar">
            {/* <div className="intimate-affinity-avatar-mic">
                {data?.searchMicImage ?
                  <img src={Util.transImgUrl(data?.searchMicImage, '50x50')} alt="" />
                  : null}
              </div> */}
            <img src={Util.transImgUrl(data.searchAvatar, '50x50')} alt="" />
          </div>
          <div
            className="intimate-affinity-item-top-name"
            style={{ color: data?.relationConfig?.relationConfigStyle }}
          >
            {data.searchNickName}
          </div>
        </div>
        <div className="intimate-affinity-item-top-center">
          {data?.keepsakeWallList ? (
            <img
              src={Util.transImgUrl(
                data?.keepsakeWallList?.[0]?.staticPic,
                '50x50'
              )}
              alt=""
            />
          ) : null}
        </div>
        <div className="intimate-affinity-item-top-right">
          <div className="intimate-affinity-item-top-avatar">
            {/* <div className="intimate-affinity-avatar-mic">
                {data?.otherMicImage ?
                  <img src={Util.transImgUrl(data?.otherMicImage, '50x50')} alt="" />
                  : null}
              </div> */}
            <img src={Util.transImgUrl(data.otherAvatar, '50x50')} alt="" />
          </div>
          <div
            className="intimate-affinity-item-top-name"
            style={{ color: data?.relationConfig?.relationConfigStyle }}
          >
            {data.otherNickName}
          </div>
        </div>
      </div>
      {data?.keepsakeWallList?.length > 1 && data.level >= 5 ? (
        <div className="intimate-affinity-item-bottom">
          {data.keepsakeWallList.map((keep) => (
            <div
              className="intimate-affinity-item-bottom-cell"
              key={keep.giftId}
            >
              <img src={Util.transImgUrl(keep.staticPic, '50x50')} alt="" />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  ) : (
    <div
      className={`intimate-affinity-item lv${data.level}`}
      style={{ backgroundImage: `url(${Util.transImgUrl(data?.relCardIcon)})` }}
      key={data.intimateRelationId}
      onClick={() => openAffinitySpace(data)}
    >
      <div className="intimate-affinity-item-level">
        <span style={{ color: data?.relationConfig?.relationConfigStyle }}>
          {data?.relationConfig?.relationConfigName}LV.{data.level}
        </span>
      </div>
      <div className="intimate-affinity-item-cover">
        <img
          src={Util.transImgUrl(
            data?.keepsakeWallList?.[0]?.staticPic,
            '100x100'
          )}
          alt=""
        />
      </div>
      <div className="intimate-affinity-item-avatar">
        <img src={Util.transImgUrl(data.otherAvatar, '50x50')} alt="" />
      </div>
      <div className="intimate-affinity-item-name">{data.otherNickName}</div>
    </div>
  );
};

export default IntimateAffinityCard;
